import React, { useState } from "react";
import ContractDetailsPopup from "./ContractDetailsPopup";
import CustomTooltip from "../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faEdit,
  faEye,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

const ContractActionButton = ({
  id,
  setEdit,
  setContractId,
  toggleShowAddEditAsset,
  contract_file,
  toggleShowDelete,
  used,
}) => {
  const [showView, setShowView] = useState(false);

  const toggleShowModal = () => {
    setShowView(!showView);
  };

  const handleDownload = async (url) => {
    try {
      if (url) {
        var a = document.createElement("a");
        a.href = url;
        var file = url.split("/");
        a.setAttribute("download", file[file.length - 1] || "file.pdf");
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    } catch (e) {}
  };
  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"View"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleShowModal}
              icon={faEye}
              size="1x"
              data-toggle="modal"
              data-target="#clientDetail"
            />
          </span>
        </CustomTooltip>
        <span>/</span>
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={() => {
                setEdit(true);
                toggleShowAddEditAsset();
                setContractId(id);
              }}
            />
          </span>
        </CustomTooltip>
        {contract_file && (
          <>
            <span>/</span>
            <CustomTooltip message={"Download"}>
              <span>
                <FontAwesomeIcon
                  icon={faDownload}
                  size="1x"
                  onClick={() => {
                    handleDownload(contract_file);
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        )}
        {used ? (
          <></>
        ) : (
          <>
            <span>/</span>
            <CustomTooltip message={"Delete"}>
              <span>
                <FontAwesomeIcon
                  icon={faTrash}
                  size="1x"
                  onClick={() => {
                    setContractId(id);
                    toggleShowDelete();
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        )}
      </span>

      {showView && (
        <ContractDetailsPopup
          showView={showView}
          contractId={id}
          toggleShowModal={toggleShowModal}
          setShowView={setShowView}
        />
      )}
    </>
  );
};

export default ContractActionButton;
